import { render, staticRenderFns } from "./Aereos.vue?vue&type=template&id=5fb06747"
import script from "./Aereos.vue?vue&type=script&lang=js"
export * from "./Aereos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports